export default __webpack_public_path__ + "static/media/Welcome-Number.f658b23a.svg";